import Base from 'app/views/base';
import tmpl from 'templates/loader';

const loaderTypes = {
  spin: 'spin', // a spinning circle
  flat: 'flat', // dots on a flat line
};

export default Base.extend({
  compiledTemplate: tmpl,

  initialize(options) {
    // show loader on page load
    this.showLoader = options.showOnLoad || true;
    this.type = options.type || loaderTypes.spin;

    const modelOrCollection = this.collection || this.model;

    this.listenTo(modelOrCollection, 'request', () => {
      this.showLoader = true;
      this.render();
    }).listenTo(modelOrCollection, 'sync error reset', () => {
      this.showLoader = false;
      this.render();
    });
  },

  context() {
    return {
      showLoader: this.showLoader,
      type: this.type,
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/loader.js